import { Component, OnInit } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrls: ["./about-us.component.scss"],
  animations: fuseAnimations,
})
export class AboutUsComponent implements OnInit {
  pageLoader: boolean = false;
  pageLoaderText: string = "Loading...";
  isLoading: boolean = true;

  constructor() {}

  ngOnInit(): void {}
}
